import FormatItem from '@/assets/formats/format-item'

import RirekishoSample from '@/assets/formats/sample/rirekisho-sample'
import RirekishoDesign001Sample from '@/assets/formats/sample/rirekisho-design001-sample'
import RirekishoCards from '@/assets/formats/rirekisho-cards'
import RirekishoJISCards from '@/assets/formats/rirekisho-jis-cards'
import NewRirekishoCards from '@/assets/formats/new-rirekisho-cards'
import RirekishoNophotoCards from '@/assets/formats/rirekisho-nophoto-cards'
import DesignRirekisho001Cards from '@/assets/formats/design-rirekisho001-cards'
import DesignRirekisho001Edit from '@/components/formats/DesignRirekisho001Edit'
import DesignRirekisho001Preview from '@/components/formats/DesignRirekisho001Preview'

import RirekishoEdit from '@/components/formats/RirekishoEdit'
import NewRirekishoEdit from '@/components/formats/NewRirekishoEdit'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import RirekishoShortPreview from '@/components/formats/RirekishoShortPreview'
import RirekishoSinglePreview from '@/components/formats/RirekishoSinglePreview'
import NewRirekishoSinglePreview from '@/components/formats/NewRirekishoSinglePreview'
import RirekishoDoubleNophotoPreview from '@/components/formats/RirekishoDoubleNophotoPreview'
import RirekishoSingleNophotoPreview from '@/components/formats/RirekishoSingleNophotoPreview'

import ShokurekishoEdit from '@/components/formats/ShokurekishoEdit'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
// import ShokurekishoPreview from '@/components/formats/ShokurekishoPreviewSample'
import ShokurekishoSample from '@/assets/formats/sample/shokurekisho-sample'
import ShokurekiCards from '@/assets/formats/shokureki-cards'


import LetterEdit from '@/components/formats/LetterEdit'
import LetterSample from '@/assets/formats/sample/letter-sample'
import LetterPreview from '@/components/formats/LetterPreview'
import LetterCards from '@/assets/formats/letter-cards'
import Kr1RirekishoEdit from "@/components/formats/Kr1RirekishoEdit.vue";
import RirekishoKr1Cards from "@/assets/formats/rirekisho-kr1-cards";
import Kr1RirekishoPreview from "@/components/formats/Kr1RirekishoPreview.vue";

import Kr2RirekishoEdit from "@/components/formats/Kr2RirekishoEdit.vue";
import RirekishoKr2Cards from "@/assets/formats/rirekisho-kr2-cards";
import Kr2RirekishoPreview from "@/components/formats/Kr2RirekishoPreview.vue";
import RirekishoSample2 from "@/assets/formats/sample/rirekisho-sample2";

const jobChangeExampleSentences = {
  // 志望動機
  reason: {
    '스킬업을 위해 이직하고 싶다': '이전 직장에서는 X년간 XX업무에 종사해 왔습니다.귀사의 XX에 대해서는 예전부터 흥미를 느꼈고 XX한 부분에 매우 매력을 느낍니다.지금까지의 경험을 살리면서 XX등의 스킬을 더 익혀 귀사의 XX업무에 공헌하고 싶다고 생각하여 지원하게 되었습니다.',
    '사업내용에 관심이 있다': '귀사가 추진하고 있는 XX사업에 관심이 있어 응모하게 되었습니다.특히 XX한 점에 매우 매력적이라고 느끼고 있습니다.지금까지의 저의 경험을 최대한 활용하면서 꼭 귀사의 일원으로서 그 성장에 관여하고 싶습니다.',
    '자신의 경험을 살리고 싶다': '나의 XXX라는 경험과 스킬을 활용하여 귀사에 공헌할 수 있을 것 같아 이번에 지원하게 되었습니다.지금까지의 경험을 살리면서 새로운 업무에도 도전하고 귀사의 사업과 조직 성장에 기여하면서 저도 성장할 것입니다.',
    '기업의 비전에 공감했다': '귀사의 XXXX라는 기업 비전에 공감하는 것이 있어 이번에 지원하게 되었습니다.저 자신도 XXXX라는 점을 소중히 여기고 있으며, 그런 비전을 소중히 여기는 분들과 함께 일하고 싶습니다.',
    '현직자에게 매력을 느꼈다': '귀사에서 일하고 있는 사원분들을 XXXX에서 보고, 그 일하는 방식에 매력을 느껴 지원하게 되었습니다.그중에서도 XXX라는 점이 자신의 가치관이나 업무감에 가깝다고 느꼈습니다.XXXX를 함으로써 귀사에 가치를 기여하고 싶습니다.',
    '새로운 직종으로 이직하고 싶다': '이전직장에서는 XX에 종사했지만, 보다 XX에 공헌할 수 있는 일을 하고 싶다고 생각했습니다.이번 귀사의 XX 구인을 보고 저도 이러한 환경에서 도전해보고 싶다는 생각에 이직을 결심하게 되었습니다.',
  },
  // 資格
  license: {
    '자동차면허(자동)': '자동차면허 1종보통',
    '자동차면허(수동)': '자동차면허 2종보통',
    'TOEIC': 'TOEIC 공개시험 XXX점 취득',
    'TOEFL': 'iBT 테스트 스코어 X점 취득'
  },
  // 본인희망란
  request: {
    '연락 가능 시간대': '연락 가능 시간대: 전화의 경우 평일 18시 이후 또는 토, 일, 공휴일.현재 재직중이라 평일 낮 연락은 메일로 보내주시면 감사하겠습니다.',
    '희망퇴근시간': '어린이집 마중을 위해 매주 수요일은 18시에 퇴근시켜 주시면 감사하겠습니다.',
    '희망업무': '희망직종: XX직을 희망합니다.',
    '희망연봉': '현재 연봉은 OOO 만원입니다.희망 연봉은 XXX 만원입니다.',
    '특별한 희망이 없는 경우': '귀사 규정에 따릅니다.'
  }
}

const licenseCommon = {
  '原付免許': '原動機付自転車免許取得',
  '自動車免許': '普通自動車第一種運転免許取得',
  '自動車免許(AT限)': '普通自動車第一種運転免許(AT限定)取得',
  '英検': '実用英語技能検定X級合格',
  'TOEIC': 'TOEIC公開テストXXX点取得',
  'TOEFL': 'iBTテストスコアX点取得',
  '日商簿記': '日商簿記検定試験X級合格',
  'ファイナンシャルプランナー': 'ファイナンシャルプランナーX級合格'
}

const formatsIndex = [
  new FormatItem({
    id: 'rirekisho_design_001',
    title: '오리지널 이력서',
    description: '구시대의 한정된 포멧의 이력서에서 탈피! 보다 간단하게 입력하여 보다 멋진 이력서를 사용하고 싶으신 분을 위한 이력서',
    thumbnail: '/kr/resume/static/img/formats/design_format_001.png',
    images: [
      '/kr/resume/static/img/formats/sample/design_format_001.png'
    ],
    newdetail1: 'A4사이즈/2장',
    newdetail2: '',
    newdetail3: '회사 입사용으로 추천합니다',
    newdetail: '차별화된 디자인',
    pagenumbs: '2장이상',
    requiredBasicFields: ['name', 'birth', 'sex', 'address', 'tel', 'email', 'photo'],
    hashs: ['履歴書', '転職'],
    components: {
      edit: DesignRirekisho001Edit,
      preview: DesignRirekisho001Preview
    },
    cards: DesignRirekisho001Cards,
    sampleData: RirekishoDesign001Sample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_kr_1',
    title: '스탠다드 이력서',
    description: '지원동기, 특기가 포함된 이력서 양식으로 학력, 경력, 자격사항이 세부적으로 분류되어 있는 이력서.',
    thumbnail: '/kr/resume/static/img/formats/sample/rirekisho_kr1_01.png',
    images: [
      '/kr/resume/static/img/formats/sample/rirekisho_kr1_01.png',
      '/kr/resume/static/img/formats/sample/rirekisho_kr1_02.png'
    ],
    newdetail1: 'A4사이즈/２장',
    newdetail2: '',
    newdetail3: '회사 입사용으로 추천합니다',
    newdetail: '회사입사용',
    pagenumbs: '2장',
    requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
    hashs: ['履歴書', '転職'],
    components: {
      edit: Kr1RirekishoEdit,
      preview: Kr1RirekishoPreview
    },
    cards: RirekishoKr1Cards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  // new FormatItem({
  //   id: 'rirekisho_kr_2',
  //   title: '상세이력서',
  //   description: '지원동기, 특기가 포함된 이력서 양식으로 학력, 경력, 자격사항이 세부적으로 분류되어 있는 이력서.',
  //   thumbnail:  '/kr/resume/static/img/formats/sample/rirekisho_kr1_01.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_kr1_01.png',
  //     '/kr/resume/static/img/formats/sample/rirekisho_kr1_02.png'
  //   ],
  //   newdetail1: 'A4사이즈/２장',
  //   newdetail2: '',
  //   newdetail3: '회사 입사용으로 추천합니다',
  //   newdetail: '업종에 필요한 추가 어필 작성',
  //   pagenumbs: '3장',
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書', '転職'],
  //   components: {
  //     edit: Kr2RirekishoEdit,
  //     preview: Kr2RirekishoPreview
  //   },
  //   cards: RirekishoKr2Cards,
  //   sampleData: RirekishoSample2,
  //   exampleSentences: jobChangeExampleSentences
  // }),

  new FormatItem({
    id: 'rirekisho_kr_3',
    title: '경력기술서',
    description: '一般的なA4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとの実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    thumbnail: '/kr/resume/static/img/formats/sample/rirekisho_kr3_01.png',
    images: [
      '/kr/resume/static/img/formats/sample/rirekisho_kr3_01.png'
    ],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: ['name', 'email'],
    hashs: ['職務経歴書', '転職'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        { type: 'others', name: '', sentences: 'はじめての転職\n大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。' },
        { type: 'others', name: '', sentences: '2社の転職を経験\n大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。' },
        { type: 'others', name: '', sentences: '複数の転職を経験\n大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。' }
      ],
      prMessage: [
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        },
        {
          type: 'others', name: '', sentences: ''
        }
      ]
    }
  }),

  // new FormatItem({
  //   id: 'rirekisho_job_change',
  //   title: '転職用の履歴書（JIS規格）',
  //   description: '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
  //   thumbnail: '/kr/resume/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
  //   ],
  //   newdetail1: 'A4サイズ/２枚',
  //   newdetail2: '令和２年７月からスタートした新様式',
  //   newdetail3: '社会人経験多めの方におすすめ',
  //   newdetail: '社会人経験多めの方向け',
  //   pagenumbs: '2枚',
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書', '転職'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoPreview
  //   },
  //   cards: RirekishoJISCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeExampleSentences
  // }),
  // new FormatItem({
  //   id: 'rirekisho_job_new',
  //   title: '新卒用の履歴書',
  //   description: '一般的なA4サイズ2枚の新卒用履歴書テンプレートです。職歴欄がなく、学歴欄や志望動機・特技・アピールポイント・インターンシップなどを広めにしたレイアウトになっています。',
  //   thumbnail: '/kr/resume/static/img/formats/rirekisho_job_new.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_new_01.png',
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_new_02.png'
  //   ],
  //   newdetail1: 'A4サイズ/２枚',
  //   newdetail2: '職歴欄なし',
  //   newdetail3: '学歴・志望動機・アピール欄が広め',
  //   newdetail: '職歴欄なしでアピール欄広め',
  //   pagenumbs: '2枚',
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書', '新卒', '学生'],
  //   components: {
  //     edit: NewRirekishoEdit,
  //     preview: NewRirekishoPreview
  //   },
  //   cards: NewRirekishoCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: {
  //     // 志望動機
  //     reason: {
  //       '業務内容に関心がある': '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。',
  //       '自身の経験を活かしたい': '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。',
  //       '企業のビジョンに共感した': '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。',
  //       'インターンシップの経験を活かしたい': '実際に業務を体験してみて、作成した資料が分かりにくいと指摘を受けることがありました。どうすれば分かりやすい資料を作成できるか繰り返し試みました。自分にとって社会へ出た際の大きな課題であると気付く機会となり、自身が成長できる可能性を感じました。',
  //       '得意科目': '私の得意科目は数学です。難しい問題でも必ず正解があり、正解にたどり着いた時の達成感を感じることが好きです。また、難解な問題への取り組みを通して、根気強く物事を考えたり、書籍やインターネットで調べるなど多種の手段で解決する経験を積んできました。論理的な課題解決能力で貴社に貢献したいです。',
  //       'ゼミ研究': '私が所属しているゼミでは、毎週課題テーマを設定し、研究結果を発表する機会があります。プレゼンテーションをするのは初めてだったので、当初は資料作成も発表もうまくできませんでした。経験を重ねることで、書籍や文献などから知識を得て資料にまとめたり、質問に対しての返答などができるようになっていきました。研究を通じて、物事を柔軟に考える重要性を学びました。',
  //       'ボランティア活動': 'XX震災後、私は復興支援活動としてXX地区の瓦礫撤去作業を行いました。チームリーダーを担当し、自分から率先して動いたり、周りに指示を出したりしながら活動しました。活動する中で、周りに指示を出すことの難しさや協力することの大切さを知りました。この経験で培ったリーダーシップや行動力を貴社で活かしたいと思っています。',
  //       '学生時代のアルバイト経験': '小売りのお店でアルバイトしていたことがあります。働いていたお店の売上が振るわない時期がありました。接客時に、同じ商品について複数回聞かれることがあり、責任者にディスプレイ方法の変更を提案したところ、来客数が増え、売上が前年比でアップすることがありました。この経験で得た客観的に判断する能力を活かしていきたいと考えています。',
  //       '自己PR': '私の長所は、コツコツと仕事を続けられる、継続力があるところです。大学で所属していたXXサークルの合宿は、部員全員の意見をまとめ、決定しています。私は100人以上いる部員の意見をまとめるために、アンケートを作成し、意見を聞き、集計していました。スケジュール管理も大変でしたが、全員の意見をまとめることがとても大変でした。この経験から、継続的な仕事を続けることができると考えております。'
  //     },
  //     // 資格
  //     license: licenseCommon,
  //     // 본인희망란
  //     request: {
  //       '連絡可能な時間帯': '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。',
  //       '帰社時間の希望': '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。',
  //       '希望職種': '希望職種：XX職を希望します。',
  //       '勤務地の希望': '希望勤務地：XX店',
  //       '希望年収': '希望年収はXXX万円となります。',
  //       '特に希望がない場合': '貴社規定に従います。'
  //     }
  //   }
  // }),
  // new FormatItem({
  //   id: 'rerekisho_part_time',
  //   title: 'アルバイト用の履歴書',
  //   description: 'アルバイト用の履歴書テンプレート（A4サイズ2枚）です。勤務曜日・勤務期間の希望などを例文から選び、素早く応募書類を作成できます。',
  //   thumbnail: '/kr/resume/static/img/formats/rirekisho_part_time.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_short_01.jpg',
  //     '/kr/resume/static/img/formats/sample/rirekisho_short_02.jpg'
  //   ],
  //   newdetail1: 'A4サイズ/２枚',
  //   newdetail2: '',
  //   newdetail3: '勤務曜日・勤務期間などの記載枠あり',
  //   newdetail: '勤務曜日・勤務期間記入可能',
  //   pagenumbs: '2枚',
  //   requiredBasicFields: ['all'],
  //   hashs: ['履歴書', 'バイト', 'パート', '学生'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoShortPreview
  //   },
  //   cards: RirekishoCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: {
  //     // 志望動機
  //     reason: {
  //       '仕事内容に興味がある': 'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。未経験ではありますが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。',
  //       'スキル・経験を活かす': '以前、同業種でX年間アルバイトをしていた経験があります。ひと通りの業務経験があるため、貴店での勤務時もお役に立てる場面があるかと思います',
  //       'お店（会社）に好感を持った': '貴店を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、学校から貴店までの距離も近いため、ぜひ長期間勤めたいと考えています。',
  //       '自分の経験を活かす': '大学ではXXについて学んでおり、より知識や経験を深めたいと考え今回応募いたしました。',
  //       '就活に活かしたい': 'XX業界への就職を目指しており、関連するアルバイトをしたいと考えています。少しでも実際の業務に触れる機会を得ることで、経験を身に付けたいと考えています。'
  //     },
  //     // 資格
  //     license: licenseCommon,
  //     // 본인희망란
  //     request: {
  //       '希望職種': '希望職種：XXを希望します',
  //       '帰社時間の希望': '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。',
  //       '勤務シフトの希望': '勤務可能日：月・火・水・土。週3～4日勤務希望です',
  //       '勤務地の希望': '希望勤務地：XX店',
  //       '希望年収': '現在の年収はOOO万円です。希望年収はXXX万円となります。',
  //       '特に希望がない場合': '貴社規定に従います。'
  //     }
  //   }
  // })
  // new FormatItem({
  //   id: 'rirekisho_wareki',
  //   title: '【和暦】転職用の履歴書（JIS規格）',
  //   description: '（ベータ版）和暦表記の日本工業規格（JIS）の規格に従ったA4サイズの一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
  //   thumbnail: '/kr/resume/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/kr/resume/static/img/formats/sample/rirekisho_job_change_02.jpg'
  //   ],
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoPreviewWareki
  //   },
  //   cards: RirekishoCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeExampleSentences
  // })
]


// if (process.env.VUE_APP_MODE !== 'production') {
//   formatsIndex.push(new FormatItem({
//     id: 'shokumukeirekisho',
//     title: '職務経歴書',
//     description: '（ベータ版）A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。',
//     // thumbnail: '/kr/resume/static/img/formats/rirekisho_job_change.png',
//     thumbnail: '/kr/resume/static/img/formats/shokurekisho-min.png',
//     images: [
//       // '/kr/resume/static/img/formats/sample/rirekisho_job_change_01.jpg',
//       // '/kr/resume/static/img/formats/sample/rirekisho_job_change_02.jpg'
//       '/kr/resume/static/img/formats/sample/shokurekisho.png'
//     ],
//     requiredBasicFields: ['name'],
//     hashs: ['職務経歴書'],
//     components: {
//       edit: ShokurekishoEdit,
//       preview: ShokurekishoPreview
//     },
//     // cards: RirekishoCards,
//     cards: ShokurekiCards,
//     sampleData: ShokurekishoSample,
//     // exampleSentences: jobChangeExampleSentences
//     exampleSentences: {
//       summary: [
//         {type: 'others', name: 'はじめての転職', sentences: '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'},
//         {type: 'others', name: '2社の転職を経験', sentences: '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'},
//         {type: 'others', name: '複数社の転職を経験', sentences: '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'}
//         // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
//         // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
//         // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
//         // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
//       ],
//       prMessage: [
//         {type: 'others', name: 'スキルをアピール', sentences: '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
//         },
//         {type: 'others', name: '同業種・業界での経験をアピール', sentences: '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: 'マネジメント経験をアピール', sentences: '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: '事務能力の高さ・効率性をアピール', sentences: 'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
//         }
//         // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
//         // },
//         // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
//         // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
//         // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
//       ]
//     }
//   }))
// }
export default formatsIndex
